import { Injectable } from '@angular/core';
import { SearchResultsModel } from '../../api/models/SearchResultsModel';
import { BehaviorSubject } from 'rxjs';
import { SessionEventsService } from '../../api/session-events.service';

const SEARCH_HISTORY_KEY = 'gt2_search_history';
const MAX_SEARCH_HISTORY = 10;

@Injectable({
  providedIn: 'root',
})
export class SearchResultsSharedDataService {
  searchData?: SearchResultsModel;
  searchDataChange: BehaviorSubject<any> = new BehaviorSubject({});
  searchString?: string;

  constructor(private sessionEvents: SessionEventsService) {
    this.sessionEvents.logout$.subscribe(() => this.reset());
  }

  public reset(): void {
    this.searchData = undefined;
    this.searchString = undefined;
    this.searchDataChange.next({});
    this.clearSearchHistory();
  }

  setSearchData(data: SearchResultsModel, searchString: string) {
    this.searchData = data;
    this.searchString = searchString;
    this.searchDataChange.next(this.searchData);
    this.addToSearchHistory(searchString);
  }

  addToSearchHistory(term: string): void {
    if (!term || term.trim() === '') {
      return;
    }
    const trimmedTerm = term.trim();
    let history = this.getSearchHistory();

    history = history.filter((h) => h.toLowerCase() !== trimmedTerm.toLowerCase());
    history.unshift(trimmedTerm);

    if (history.length > MAX_SEARCH_HISTORY) {
      history = history.slice(0, MAX_SEARCH_HISTORY);
    }

    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
  }

  getSearchHistory(): string[] {
    try {
      const stored = localStorage.getItem(SEARCH_HISTORY_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (e) {
      console.error('Error reading search history', e);
    }
    return [];
  }

  clearSearchHistory(): void {
    localStorage.removeItem(SEARCH_HISTORY_KEY);
  }
}
